import { getTimestamp, addDays } from '@/assets/utils/time.js';
import { isTokenValid } from '@/assets/utils/oneapp';
import axios from 'axios';

export default class MqdcOneClient {
  constructor (axios) {
    this.universalUrl = process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdcone/getclienttoken';
    this.headers = { 'accept': 'application/json', 'Authorization': '', 'content-type': 'application/json;charset=utf-8' };
    this.axios = axios;
  }

  async getMqdcOneToken () {
    if (!isTokenValid(new Date())) {
      const response = await this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdcone/getclienttoken');
      const token = response.data.data.token;
      if (token) {
        await this.setToken(token);
      }
      return token;
    } else {
      return sessionStorage.getItem('clientToken');
    }
  }

  async setToken (token) {
    const today = new Date();
    const tomorrow = addDays(today, 2);
    sessionStorage.setItem('clientToken', token);
    sessionStorage.setItem('clientTokenExpirationDate', getTimestamp(tomorrow));
  }

  async getAxios () {
    const headers = { 'accept': 'application/json', 'Authorization': 'Bearer ' + await this.getMqdcOneToken(), 'content-type': 'application/json;charset=utf-8' };
    return axios.create({ headers: headers });
  }
}
